import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/discover/$category")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/search", search: { category: params.category } });
  },
});
